import { CardTypeConfig } from '../../interfaces/card-type-config';

export const CARTESBANCAIRES_CARD_TYPE_NAME = 'cartesbancaires';

export const CARTESBANCAIRES_CARD_TYPE_CONFIG: CardTypeConfig = {
    niceType: 'CartesBancaires',
    type: CARTESBANCAIRES_CARD_TYPE_NAME,
    patterns: [
        436000
    ],
    gaps: [4, 8, 12],
    lengths: [12, 13, 14, 15, 16, 17, 18, 19],
    code: {
        name: 'CVV',
        size: 3
    }
};
